import React from "react";
import { Fuel, Users } from "lucide-react";

const ISO = {
  italia: "it", germania: "de", francia: "fr", spagna: "es", belgio: "be",
  olanda: "nl", "paesi bassi": "nl", austria: "at", svizzera: "ch",
  "regno unito": "gb", portogallo: "pt", polonia: "pl", svezia: "se",
  danimarca: "dk", lussemburgo: "lu", "repubblica ceca": "cz", slovenia: "si",
};

const chip = "flex items-center gap-1.5 rounded-md border border-[var(--cm-line)] bg-white px-2 py-1 font-mono-cm text-[0.62rem] uppercase tracking-[0.1em] text-[#4a4a45]";

export const CarBadges = ({ car }) => {
  const iso = car.origin && ISO[car.origin.toLowerCase()];
  if (!car.fuel && car.owners == null && !car.origin) return null;
  return (
    <div className="mt-3 flex flex-wrap gap-2" data-testid={`car-badges-${car.handle}`}>
      {car.fuel && (
        <span className={chip} data-testid="car-badge-fuel">
          <Fuel size={11} strokeWidth={2.2} /> {car.fuel}
        </span>
      )}
      {car.owners != null && (
        <span className={chip} title="Numero di proprietari" data-testid="car-badge-owners">
          <Users size={11} strokeWidth={2.2} />
          {Number(car.owners) <= 1 ? "Unico proprietario" : `${car.owners} proprietari`}
        </span>
      )}
      {car.origin && (
        <span className={chip} title="Prima immatricolazione" data-testid="car-badge-origin">
          {iso && (
            <img src={`https://flagcdn.com/w20/${iso}.png`} alt="" width="14" height="10" className="rounded-[2px]" />
          )}
          {car.origin}
        </span>
      )}
    </div>
  );
};
